import { CanActivate, CanLoad, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Injectable } from '@angular/core';

@Injectable({providedIn:'root'})
export class AutoLoginGuard implements CanLoad {
  constructor(private auth: AuthService, private router: Router) { }

  canLoad(): boolean {
    // app_version
    console.log('autologin canload: '+this.auth.getToken());

    if (this.auth.getToken()) {
      console.log('autologin false');
      this.router.navigate(['/account']); // Redirect to login if not logged in
      return false;
    }

    console.log('autologin true');
    return true; // Allow access to account if logged in
  }
};
